import { DrawerProps } from "antd";
import { PropsWithChildren } from "react";
import { StyledDrawer } from "./atom";

export type RenderbusDrawerProps = PropsWithChildren<
  DrawerProps & {
    drawerContent?: JSX.Element;
  }
>;
export function Drawer({
  className = "",
  drawerContent,
  ...props
}: RenderbusDrawerProps) {
  return (
    <StyledDrawer className={`renderbus-ui--drawer ${className}`} {...props}>
      {drawerContent}
    </StyledDrawer>
  );
}
